module.exports = __webpack_public_path__ + "Flag-50.7f0542aeacf8930f23f67ee4e4ee2973.svg";